// extracted by mini-css-extract-plugin
module.exports = {"taskHeader":"TaskHeader_taskHeader__2CDFi","titleButton":"TaskHeader_titleButton__2XusH"};